import {
  Button,
  Checkbox,
  DialogActions,
  FormControlLabel,
  IconButton,
  InputAdornment,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Tooltip
} from "@material-ui/core";
import { PeopleAltOutlined } from "@material-ui/icons";
import EditIcon from "@material-ui/icons/Edit";
import SearchIcon from "@material-ui/icons/Search";
import { Pagination } from "@material-ui/lab";
import cn from "classnames";
import ButtonComponent from "components/Button";
import Flex from "components/Flex";
import TagPreviewItem from "components/TagPreviewItem";
import _ from "lodash";
import { useEffect, useState, useRef } from "react";
import { X } from "react-feather";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { selectFanpageSelected } from "views/Customer/CustomerSelectors";
import fanpageApi from "../../api/fanpageApi";
import { showError, showSuccess } from "../../stores/alert/slice.alert";
import { closeLoading, openLoading } from "../../stores/loading/slice.loading";
import CustomersInBomBotTagModal from "../CustomersInTagModal/CustomersInBomBotTagModal";
import Confirm from "../Modals/Confirm";
import RenameTagModal from "../RenameTagModal";
import { Trash2Icon, TrashIcon } from "lucide-react";
import ModalConfirm from "components/Modals/ModalConfirm";
import styles from "../../views/Tag/TagView.module.scss";

const useStyles = makeStyles({
  widthCheckBox: {
    // minWidth: "60px",
    height: "52px"
    // width: "4%"
  },
  widthSeq: {
    minWidth: "80px",
    padding: "0 8px !important"
  },
  widthId: {
    minWidth: "146px",
    padding: "0 8px !important"
  },
  widthName: {
    minWidth: "220px",
    padding: "0 8px !important"
  },
  widthCreatedAt: {
    minWidth: "220px",
    padding: "0 8px !important"
  },
  widthCreatedBy: {
    minWidth: "220px",
    padding: "0 8px !important"
  },
  widthQuantityCus: {
    minWidth: "120px",
    padding: "0 8px !important"
  },
  widthActions: {
    minWidth: "140px",
    width: "6%",
    padding: "0 8px !important"
  },
  p0: {
    padding: "0",
    margin: "0"
  },
  heightHeader: {
    height: "52px"
  },
  f600: {
    fontWeight: 600
  },
  checkBoxPadding: {
    padding: "10px 20px"
  },
  actions: {
    display: "flex",
    alignItems: "center",
    width: "100%",
    justifyContent: "space-between",
    marginTop: "10px"
  },
  closeBtn: {
    color: "#ffffff",
    backgroundColor: "#dc3545",
    border: "2px solid #dc3545",
    padding: "6px 20px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#c82333",
      borderColor: "#bd2130"
    }
  },
  submitBtn: {
    color: "white",
    backgroundColor: "#28a745",
    border: "2px solid #28a745",
    padding: "6px 26px",
    borderRadius: "4px",
    cursor: "pointer",
    margin: "0 36px !important",
    "&:hover": {
      backgroundColor: "#218838",
      borderColor: "#1e7e34"
    }
  },
  numCusInp: {
    fontSize: "14px",
    display: "flex",
    justifyContent: "end",
    alignItems: "center"
  },
  footerContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    padding: "0 26px",
    margin: "12px 0",
    minHeight: "48px"
  },
  container: {
    flex: 1,
    width: "100%"
  },
  paginationBottom: {
    display: "flex !important",
    justifyContent: "end !important",
    alignItems: "center !important"
  },
  buttonLoadMore: {
    alignItems: "center",
    appearance: "none",
    backgroundColor: "#fff",
    border: "1px solid #dbdbdb",
    borderRadius: ".375em",
    boxShadow: "none",
    boxSizing: "border-box",
    color: "#363636",
    cursor: "pointer",
    display: "inline-flex",
    fontFamily: `BlinkMacSystemFont, -apple-system, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", Helvetica, Arial, sans-serif`,
    fontSize: "0.8rem",
    height: "1.8em",
    justifyContent: "center",
    lineHeight: "1.5",
    padding: "calc(.5em - 1px) 1em",
    position: "relative",
    textAlign: "center",
    userSelect: "none",
    WebkitUserSelect: "none",
    touchAction: "manipulation",
    verticalAlign: "top",
    whiteSpace: "nowrap",
    "&:hover": {
      borderColor: "#b5b5b5"
    },
    "&:active": {
      borderColor: "#4a4a4a",
      outline: "0"
    },
    "&:focus": {
      borderColor: "#485fc7",
      outline: "0"
    },
    "&:focus:not(:active)": {
      boxShadow: "rgba(72, 95, 199, 0.25) 0 0 0 0.125em"
    }
  },
  rowItem: {
    cursor: "pointer"
  },

  noData: {
    color: "rgba(0,0,0,.5)",
    fontWeight: "bold",
    textAlign: "center",
    padding: "24px"
  },
  closeButton: {
    position: "absolute",
    right: 0,
    top: "50%",
    transform: "translateY(-50%)",
    color: "#637381",
    padding: "8px",
    marginRight: "8px",
    "&:hover": {
      color: "#212B36",
      backgroundColor: "rgba(99, 115, 129, 0.08)",
      borderRadius: "50%"
    }
  },
  dialogTitle: {
    position: "relative",
    paddingRight: "48px",
    margin: 0,
    padding: "16px 24px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between"
  }
});

const countRowPerPages = 10;

export const tagType = {
  BOMBOT_TAGS: "BOMBOT_TAGS",
  FACEBOOK_TAGS: "FACEBOOK_TAGS"
};

const BombotTagsManagement = ({
  getData,
  getFanpage,
  setIsLoading,
  onDataLoad,
  filter = 'ALL',
  onFilterChange
}) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const pageSelected = useSelector(selectFanpageSelected);
  const [page, setPage] = useState(0);
  const [bombotTagData, setBombotTagData] = useState([]);
  const [searchVal, setSearchVal] = useState("");
  const [openConfirmDelete, setOpenConfirmDelete] = useState(false);
  const [renameSelected, setRenameSelected] = useState(null);
  const [selectedTag, setSelectedTag] = useState(null);

  const [checkedList, setCheckedList] = useState({});
  const [selectedCount, setSelectedCount] = useState(0);
  const [toastMsg, setToastMsg] = useState(null);
  const toastTimer = useRef(null);
  const pageIdRef = useRef(pageSelected?.id);
  pageIdRef.current = pageSelected?.id;

  const dispatch = useDispatch();

  const getBombotTags = async (page) => {
    if (!pageSelected.id) return;

    let search = null;

    if (searchVal.trim()) {
      search = `id|name==${searchVal}`;
    }

    let params = {
      id: pageSelected.id,
      page: page,
      size: countRowPerPages
    };

    if (!_.isNull(search)) {
      params = {
        id: pageSelected.id,
        page: page,
        size: countRowPerPages,
        search
      };
    }

    const fanpageId = pageSelected.id;
    return fanpageApi.getBomBotTagList(fanpageId, params).then((res) => {
      if (fanpageId !== pageIdRef.current) return res;
      setBombotTagData(res);
      if (onDataLoad && res?.statistic) {
        const statistic = res.statistic;
        onDataLoad({
          total: statistic.total ?? 0,
          used: statistic.used ?? 0,
          empty: statistic.empty ?? 0,
          system: statistic.system ?? 0,
        });
      }
      return res;
    });
  };

  useEffect(() => {
    (async () => {
      try {
        setIsLoading(true);
        await getBombotTags(page);
      } catch (error) {
        dispatch(showError(t('setting_account.tag_error_generic')));
      } finally {
        setIsLoading(false);
      }
    })();
  }, [pageSelected?.id, page]);

  useEffect(() => {
    setSelectedCount(0);
    setCheckedList({});
  }, [pageSelected?.id]);

  const handleSearch = async () => {
    setIsLoading(true);
    try {
      setPage(0);
      await getBombotTags(0);
    } catch (error) {
      dispatch(showError(t('setting_account.tag_error_generic')));
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleCheckTag = (isChecked, tagId) => {
    setCheckedList((prev) => ({
      ...prev,
      [tagId]: isChecked
    }));

    // Cập nhật selectedCount khi chọn hoặc bỏ chọn tag
    const count =
      Object.keys(checkedList).filter((id) => checkedList[id]).length +
      (isChecked ? 1 : -1);
    setSelectedCount(count);
  };

  const handleCheckAllTag = (isChecked) => {
    const currentPageTags = bombotTagData?.content;
    let checkListTmp = {};
    if (isChecked) {
      currentPageTags.forEach((tag) => {
        checkListTmp[tag.id] = true; // Đánh dấu tất cả tag là đã chọn
      });
      setSelectedCount(currentPageTags.length); // Cập nhật selectedCount
    } else {
      currentPageTags.forEach((tag) => {
        checkListTmp[tag.id] = false; // Bỏ chọn tất cả tag
      });
      setSelectedCount(0); // Đặt lại selectedCount
    }
    setCheckedList(checkListTmp);
  };

  const handleDeleteSearch = () => {
    setSearchVal("");
    setPage(0);
  };

  const handleSubmitDeleteTags = () => {
    const count = Object.keys(checkedList).filter(
      (tagId) => checkedList[tagId]
    ).length;
    if (count === 0) {
      dispatch(showError(t('setting_account.tag_error_select_least_one')));
      return;
    }
    setSelectedCount(count); // Cập nhật selectedCount trước khi mở modal xác nhận
    setOpenConfirmDelete(true);
  };

  const handleDeleteTags = async () => {
    try {
      dispatch(openLoading());
      await fanpageApi.deleteBomBotTagList(pageSelected?.id, {
        tagId: Object.keys(checkedList).filter((tagId) => checkedList[tagId])
      });

      getFanpage();
      const res = await getBombotTags(page);

      if (res && res.content.length === 0 && page > 0) {
        setPage(page - 1);
      }

      setOpenConfirmDelete(false);
      dispatch(showSuccess(t('setting_account.tag_delete_success', { count: selectedCount })));
      setCheckedList({});
      setSelectedCount(0); // Reset selectedCount sau khi xóa
    } catch (error) {
      dispatch(showError(error.message));
    } finally {
      dispatch(closeLoading());
    }
  };

  const handleRenameTag = async (renameTag, newName) => {
    try {
      dispatch(openLoading());

      const payload = {
        name: newName
      };

      await fanpageApi.renameTag(pageSelected.id, renameTag.id, payload);

      setBombotTagData((prevData) => {
        return {
          ...prevData,
          content: prevData.content.map((tag) => {
            if (tag.id === renameTag.id) {
              return { ...tag, name: newName };
            }
            return tag;
          })
        };
      });

      getFanpage();
    } catch (error) {
      console.log(error);
      dispatch(showError(error.message));
    } finally {
      setRenameSelected(null);
      dispatch(closeLoading());
    }
  };

  useEffect(() => {
    console.log("checkedList ==>", checkedList);
  }, [checkedList]);

  useEffect(() => {
    console.log("bombotTagData ==>", bombotTagData);
  }, [bombotTagData]);

  const copyText = (text, e) => {
    e.stopPropagation();
    if (navigator.clipboard) {
      navigator.clipboard.writeText(String(text));
      setToastMsg(t('tag_page.copy_id_toast', { id: text }));
      if (toastTimer.current) clearTimeout(toastTimer.current);
      toastTimer.current = setTimeout(() => setToastMsg(null), 2500);
    }
  };

  return (
    <>
      <div className={styles.toolbar}>
        <div id="tag_search" className={styles.searchWrap}>
          <svg viewBox="0 0 16 16" fill="none"><circle cx="7" cy="7" r="4.5"/><path d="M13.5 13.5l-3-3"/></svg>
          <input
            className={styles.searchInput}
            type="text"
            placeholder={t('tag_page.search_placeholder')}
            value={searchVal}
            onChange={(e) => setSearchVal(e.target.value)}
            onKeyDown={(e) => { if (e.key === "Enter") handleSearch(); }}
          />
          {searchVal && (
            <button className={`${styles.searchClear} ${styles.show}`} onClick={handleDeleteSearch}>
              <svg viewBox="0 0 10 10" fill="none"><path d="M1.5 1.5l7 7M8.5 1.5l-7 7"/></svg>
            </button>
          )}
        </div>
        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap' }}>
          <div
            id="tag_filter_all"
            className={`${styles.chip} ${filter === 'ALL' ? styles.on : ''}`}
            onClick={() => onFilterChange && onFilterChange('ALL')}
          >
            {t('tag_page.filter_all')} <span className={styles.chipCount}>{bombotTagData?.totalElements || 0}</span>
          </div>
          <div
            className={`${styles.chip} ${filter === 'CUSTOM' ? styles.on : ''}`}
            onClick={() => onFilterChange && onFilterChange('CUSTOM')}
          >
            {t('tag_page.filter_custom')} <span className={styles.chipCount}>{(bombotTagData?.content || []).filter(t => !t.name?.startsWith('Chiến-dịch-')).length}</span>
          </div>
          <div
            className={`${styles.chip} ${filter === 'SYSTEM' ? styles.on : ''}`}
            onClick={() => onFilterChange && onFilterChange('SYSTEM')}
          >
            {t('tag_page.filter_system')} <span className={styles.chipCount}>{(bombotTagData?.content || []).filter(t => t.name?.startsWith('Chiến-dịch-')).length}</span>
          </div>
          <div
            className={`${styles.chip} ${filter === 'EMPTY' ? styles.on : ''}`}
            onClick={() => onFilterChange && onFilterChange('EMPTY')}
          >
            {t('tag_page.filter_empty')} <span className={styles.chipCount}>{(bombotTagData?.content || []).filter(t => (t.totalCus || 0) === 0).length}</span>
          </div>
        </div>
        <select className={styles.sortSelect} defaultValue="countDesc">
          <option value="countDesc">{t('tag_page.sort_most_cus')}</option>
          <option value="countAsc">{t('tag_page.sort_least_cus')}</option>
          <option value="nameAsc">{t('tag_page.sort_name_az')}</option>
        </select>
      </div>

      {selectedCount > 0 && (
        <div className={`${styles.selectionBar} ${styles.show}`}>
          <span className={styles.selectionCount}>{t('tag_page.selected_count', { count: selectedCount })}</span>
          <div className={styles.selectionActions}>
            <button className={`${styles.btnBar} ${styles.btnBarDanger}`} onClick={handleSubmitDeleteTags}>
              <svg viewBox="0 0 14 14" fill="none"><path d="M2 3.5h10M5.5 3.5V2h3v1.5M3.5 3.5l.7 8a1 1 0 001 .9h3.6a1 1 0 001-.9l.7-8"/></svg>
              {t('tag_page.btn_delete_selected')}
            </button>
          </div>
          <span className={styles.selectionNote}>{t('tag_page.delete_note')}</span>
          <button className={styles.selectionDismiss} onClick={() => handleCheckAllTag(false)}>{t('tag_page.deselect')}</button>
        </div>
      )}

      <div className={styles.tblScroll}>
        <table className={styles.customTable}>
          <thead>
            <tr>
              <th style={{ width: 40 }}>
                <input
                  type="checkbox"
                  className={styles.cb}
                  checked={bombotTagData?.content?.length > 0 && bombotTagData?.content?.every((tag) => checkedList[tag.id])}
                  onChange={(e) => handleCheckAllTag(e.target.checked)}
                />
              </th>
              <th style={{ minWidth: 260 }}>{t('tag_page.col_tag')}</th>
              <th>{t('tag_page.col_type')}</th>
              <th className={styles.thNum} style={{ width: 120 }}>{t('tag_page.col_customers')}</th>
              <th style={{ textAlign: 'right', width: 160 }}>{t('tag_page.col_action')}</th>
            </tr>
          </thead>
          <tbody>
            {bombotTagData?.content?.length > 0 ? (
              bombotTagData.content.filter(tag => {
                if (filter === 'ACTIVE') return (tag.totalCus || 0) > 0;
                if (filter === 'EMPTY') return (tag.totalCus || 0) === 0;
                if (filter === 'SYSTEM') return tag.name?.startsWith('Chiến-dịch-');
                if (filter === 'CUSTOM') return !tag.name?.startsWith('Chiến-dịch-');
                return true;
              }).map((tag, index) => {
                const isSysTag = tag?.name?.startsWith("Chiến-dịch-");
                return (
                  <tr
                    key={tag.id}
                    className={`${styles.tagRow} ${checkedList[tag.id] ? styles.checked : ""}`}
                  >
                    <td onClick={e => e.stopPropagation()}>
                      <input
                        type="checkbox"
                        className={styles.cb}
                        checked={checkedList[tag.id] || false}
                        onChange={(e) => handleCheckTag(e.target.checked, tag.id)}
                      />
                    </td>
                    <td>
                      <div className={styles.tagCell}>
                        <div
                          className={`${styles.tagChip} ${isSysTag ? styles.tSys : styles.tCustom}`}
                          style={!isSysTag && (tag.backgroundColor || tag.color) ? { backgroundColor: tag.backgroundColor || `#${tag.color}`, color: tag.textColor || "#fff", border: "none" } : {}}
                        >
                          {isSysTag
                            ? <svg viewBox="0 0 16 16" fill="none"><rect x="2" y="4" width="12" height="9" rx="1.5"/><path d="M8 4V1.5M5.5 8h.01M10.5 8h.01M5.5 10.5h5"/></svg>
                            : <svg viewBox="0 0 15 15" fill="none"><path d="M2 2h5l6 6-5 5-6-6V2z"/><circle cx="5" cy="5" r="1"/></svg>
                          }
                          <span title={tag.name}>{tag.name}</span>
                        </div>
                        <div className={styles.tagId}>
                          ID {tag.id}
                          <button className={styles.copyBtn} title={t('tag_page.copy_id')} onClick={(e) => copyText(tag.id, e)}>
                            <svg viewBox="0 0 12 12" fill="none"><rect x="3" y="3" width="7" height="7" rx="1"/><path d="M2 8V2h6"/></svg>
                          </button>
                        </div>
                      </div>
                    </td>
                    <td>
                      <div className={`${styles.typeBadge} ${isSysTag ? styles.typeSys : styles.typeCustom}`}>
                        {isSysTag ? t('tag_page.type_system') : t('tag_page.type_custom')}
                      </div>
                    </td>
                    <td className={styles.tdNum}>
                      <div className={styles.countCell}>
                        {(tag.totalCus === 0 || !tag.totalCus) && <span className={styles.emptyFlag}>{t('tag_page.empty_flag')}</span>}
                        <span className={`${styles.countVal} ${!tag.totalCus ? styles.zero : ""}`}>
                          {tag.totalCus || 0}
                        </span>
                      </div>
                    </td>
                    <td onClick={e => e.stopPropagation()}>
                      <div className={styles.rowActions}>
                        <button className={styles.btnRow} onClick={() => setSelectedTag(tag)}>
                          <svg viewBox="0 0 15 15" fill="none"><circle cx="6" cy="5" r="2.5"/><path d="M1.5 13c0-2.8 2-4.5 4.5-4.5s4.5 1.7 4.5 4.5"/><path d="M10.5 1.8a2.5 2.5 0 010 4.9M13 13c0-2.2-1.3-3.8-3-4.3"/></svg>
                          {t('tag_page.view_customers')}
                        </button>
                        <button className={styles.btnRow} onClick={() => setRenameSelected(tag)}>
                          <svg viewBox="0 0 14 14" fill="none"><path d="M9.5 2l2.5 2.5L5 11.5l-3 .5.5-3L9.5 2z"/></svg>
                          {t('tag_page.rename')}
                        </button>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan="6">
                  <div className={styles.tblEmpty}>
                    <div className={styles.tblEmptyIcon}>
                      <svg viewBox="0 0 20 20" fill="none"><circle cx="9" cy="9" r="6"/><path d="M17 17l-4-4"/></svg>
                    </div>
                    <div className={styles.tblEmptyTitle}>{t("update.no_data")}</div>
                    <div className={styles.tblEmptySub}>{t('tag_page.empty_sub_bombot')}</div>
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {bombotTagData?.content?.length > 0 && (() => {
        const totalPages = Math.ceil((bombotTagData?.totalElements || 0) / countRowPerPages);

        // Build smart page list: 1 ... 4 5 6 ... 10
        const buildPages = (current, total) => {
          if (total <= 7) return Array.from({ length: total }, (_, i) => i);
          const pages = [];
          const addPage = (p) => { if (!pages.includes(p)) pages.push(p); };
          addPage(0);
          addPage(total - 1);
          for (let i = Math.max(0, current - 1); i <= Math.min(total - 1, current + 1); i++) addPage(i);
          pages.sort((a, b) => a - b);
          // Insert ellipsis markers (-1)
          const result = [];
          pages.forEach((p, idx) => {
            if (idx > 0 && p - pages[idx - 1] > 1) result.push(-1);
            result.push(p);
          });
          return result;
        };

        return (
          <div className={styles.tblFooter}>
            <span className={styles.tblCount}>{t('tag_page.total_count', { count: bombotTagData?.totalElements || 0 })}</span>
            <div className={styles.pagination}>
              {/* Prev */}
              <button
                className={styles.pgBtn}
                disabled={page === 0}
                onClick={() => handleChangePage(null, page - 1)}
                aria-label={t('tag_page.pg_prev')}
              >
                <svg viewBox="0 0 12 12" fill="none"><path d="M8 2L4 6l4 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>

              {/* Page numbers */}
              {buildPages(page, totalPages).map((p, idx) =>
                p === -1
                  ? <span key={`ellipsis-${idx}`} className={styles.pgBtn} style={{ border: 'none', background: 'none', cursor: 'default', minWidth: 24 }}>…</span>
                  : <button
                      key={p}
                      className={`${styles.pgBtn} ${p === page ? styles.on : ''}`}
                      onClick={() => handleChangePage(null, p)}
                    >
                      {p + 1}
                    </button>
              )}

              {/* Next */}
              <button
                className={styles.pgBtn}
                disabled={page >= totalPages - 1}
                onClick={() => handleChangePage(null, page + 1)}
                aria-label={t('tag_page.pg_next')}
              >
                <svg viewBox="0 0 12 12" fill="none"><path d="M4 2l4 4-4 4" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/></svg>
              </button>
            </div>
          </div>
        );
      })()}

      <ModalConfirm
        title={t('tag_management.confirm_delete_title')}
        content={`${t('tag_management.confirm_delete_message_1')} ${selectedCount} ${t('tag_management.confirm_delete_message_2')}`}
        onClose={() => setOpenConfirmDelete(false)}
        isOpen={openConfirmDelete}
        onConfirm={handleDeleteTags}
      />

      {!_.isNull(selectedTag) && (
        <CustomersInBomBotTagModal
          isOpen={!_.isNull(selectedTag)}
          handleClose={() => setSelectedTag(null)}
          tag={selectedTag}
          onCustomersChanged={() => {
            getBombotTags(page);
            if (getFanpage) getFanpage();
          }}
        />
      )}

      {renameSelected && (
        <RenameTagModal
          open={!_.isNull(renameSelected)}
          handleClose={() => setRenameSelected(null)}
          handleSubmit={handleRenameTag}
          renameSelected={renameSelected}
        />
      )}

      {/* Toast Copy */}
      <div className={`${styles.toast} ${toastMsg ? styles.show : ''}`}>
        <svg viewBox="0 0 14 14" fill="none"><path d="M2.5 7.5l3 3 6-6.5"/></svg>
        {toastMsg}
      </div>
    </>
  );
};

const CellSticky = styled(TableCell)`
  position: sticky;
  background-color: #fff;
  right: -1px;
  z-index: 2;
  box-shadow: -15px 0px 17px -7px #f0eded;
`;

export default BombotTagsManagement;
